export const FIREBASE_ERROR = {
  'auth/email-already-in-use': 'This email is already in use!',
  'auth/wrong-password': 'Wrong password!',
  'auth/user-not-found': 'Invalid Credentials!',
  'auth/email-not-found': 'Invalid Credentials!',
  'auth/invalid-login-credentials': 'Invalid Credentials!',
};
